import { useEffect, useState } from 'react'
import { connect } from 'react-redux'
import {
  MESSAGE_EVENT,
  ONLINE_EVENT,
  DISCONNECT_EVENT,
  OFFLINE_EVENT,
  ONLINE_EVENT_CUSTOM,
  RECONNECT_EVENT,
  OFFLINE_EVENT_CUSTOM,
  MESSAGE_EVENT_CUSTOM,
  NOTIFICATION_INITIALIZE,
  DISCONNECT_EVENT_CUSTOM,
  RECONNECT_EVENT_CUSTOM,
  UPDATE_ACCOUNT,
  FILTER_DUPLICATE_LOGIN
} from 'constants/realtimeEvent'
import { NotificationServices } from 'services'
import Cookies from 'js-cookie'
import { DisconnectOverlay, DuplicateLoginModal } from 'components/common'
import { setUser } from 'actions'
import { setWebsocketConnected } from 'actions/echo'

const Realtime = (props) => {
  const { socket, currentRightUser, dispatch, user, echoServer,
    isWebsocketConnected

   } = props
  const [isDisconnected, setIsDisconnected] = useState(false)
  const [isShowDuplicateLoginModal, setIsShowDuplicateLoginModal] = useState(false)

  const handleCloseDuplicateLoginModal = () => {
    setIsShowDuplicateLoginModal(false)
  }

  useEffect(() => {
    if (echoServer) {
      const socket = echoServer.connector.socket

      // Socket may already be connected before this effect runs
      if (socket.connected) {
        dispatch(setWebsocketConnected(true))
        setIsDisconnected(false)
      }

      const onConnect = () => {
        dispatch(setWebsocketConnected(true))
        setIsDisconnected(false)
      }
      const onDisconnect = () => {
        dispatch(setWebsocketConnected(false))
        setIsDisconnected(true)
      }
      const onReconnect = () => {
        setIsDisconnected(false)
      }

      socket.on('connect', onConnect)
      socket.on('disconnect', onDisconnect)
      socket.on('reconnect', onReconnect)

      return () => {
        socket.off('connect', onConnect)
        socket.off('disconnect', onDisconnect)
        socket.off('reconnect', onReconnect)
      }
    }
  }, [echoServer])

  return (
    <>
      <DuplicateLoginModal
        handleCloseDuplicateLoginModal={handleCloseDuplicateLoginModal}
        isShowDuplicateLoginModal={isShowDuplicateLoginModal} />
      {(isDisconnected || !isWebsocketConnected) && <DisconnectOverlay />}
    </>
  )
}

const mapStateToProps = (state) => ({
  socket: state.connectionReducer.socket,
  user: state.connectionReducer.user,
  currentRightUser: state.chatReducer.currentRightUser,
  echoServer: state.connectionReducer.echoServer,
  isWebsocketConnected: state.echoReducer.isWebsocketConnected,
})

export default connect(mapStateToProps)(Realtime)
